

































import { Component, Mixins } from "vue-property-decorator";
import mixins from "@/mixins";

@Component
class SurveyIndex extends Mixins(mixins.page) {
  level = 0;

  loading = false;

  get title() {
    return this.$t("survey") as string;
  }

  async mounted() {
    this.loading = true;
    await this.requestRiskAssessment();
    if (this.level) {
      this.toResult();
    }
    setTimeout(() => {
      this.loading = false;
    }, 200);
  }

  toStart() {
    this.$helper.toFusionPath(this, "basis", {
      name: "survey-quiz",
      query: { page: "0" }
    });
  }

  toResult() {
    this.$helper.toFusionPath(
      this,
      "basis",
      {
        name: "survey-result",
        query: { score: this.level + "" }
      },
      true
    );
  }

  async requestRiskAssessment() {
    try {
      const result = await this.$api.survey.getRiskScore();
      this.level = result.level;
    } catch (error) {
      console.log(error);
    }
  }
}
export default SurveyIndex;
